export default __webpack_public_path__ + "static/bikebike-logo-39dc2bd973d59f21e55f11aefa0414b7.png";